import type { InputHTMLAttributes, Ref } from "react";

import { cn } from "../../utils";
import styles from "./Toggle.module.scss";

export type ToggleSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface ToggleProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size" | "value"
> {
  ref?: Ref<HTMLInputElement>;
  size?: ToggleSize;
  value: boolean;
  onValueChange?: (value: boolean) => void;
}

export const Toggle = ({
  size = "sm",
  value,
  disabled = false,
  className,
  onChange,
  onValueChange,
  ref,
  ...props
}: ToggleProps) => {
  return (
    <input
      ref={ref}
      checked={value}
      type="checkbox"
      disabled={disabled}
      className={cn(
        styles.ToggleInput,
        "ui:relative ui:cursor-pointer ui:appearance-none ui:rounded-full ui:border ui:border-divider ui:bg-buttonFill ui:text-white ui:transition-colors ui:checked:border-0 ui:checked:bg-primary ui:disabled:cursor-not-allowed ui:disabled:opacity-30",
        {
          "ui:h-4 ui:w-7": size === "xs",
          "ui:h-5 ui:w-9": size === "sm",
          "ui:h-6 ui:w-11": size === "md",
          "ui:h-7 ui:w-13": size === "lg",
          "ui:h-8 ui:w-15": size === "xl",
        },
        className,
      )}
      onChange={(e) => {
        onChange?.(e);
        onValueChange?.(e.target.checked);
      }}
      {...props}
    />
  );
};
